/* OrbitaClick · Buscador con autocompletado · API nativa de Shopify · 27-08-2026
   Sin apps de pago: usa /search/suggest.json (Predictive Search API). */
(function () {
  'use strict';

  var LIMITE = 6;
  var RETARDO = 220;
  var MIN = 2;
  var moneda = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var fmt;
  try {
    fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: moneda });
  } catch (e) {
    fmt = { format: function (n) { return n.toFixed(2) + ' €'; } };
  }

  function corto(t) {
    // Los titulos del catalogo son muy largos y usan "|" como separador.
    // Nos quedamos con el primer tramo, pero si es demasiado corto
    // (p. ej. "KIMIA") vamos sumando tramos hasta que diga algo.
    var partes = String(t || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
    var s = partes[0] || '';
    var i = 1;
    while (s.length < 20 && i < partes.length) { s += ' · ' + partes[i]; i++; }
    return s.length > 70 ? s.slice(0, 69).trim() + '…' : s;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function miniatura(url) {
    if (!url) return '';
    return url.indexOf('?') === -1 ? url + '?width=96' : url + '&width=96';
  }

  function Autocompletar(input) {
    if (input.dataset.ocAc) return;
    input.dataset.ocAc = '1';

    var form = input.form;
    var caja = document.createElement('div');
    caja.className = 'oc-ac';
    caja.hidden = true;
    caja.setAttribute('role', 'listbox');
    caja.setAttribute('aria-label', 'Sugerencias de búsqueda');

    var envoltorio = input.parentNode;
    if (getComputedStyle(envoltorio).position === 'static') envoltorio.style.position = 'relative';
    envoltorio.appendChild(caja);

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');

    var temporizador = null;
    var controlador = null;
    var indice = -1;

    function cerrar() {
      caja.hidden = true;
      caja.innerHTML = '';
      indice = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function opciones() {
      return [].slice.call(caja.querySelectorAll('.oc-ac__item'));
    }

    function marcar(n) {
      var els = opciones();
      if (!els.length) return;
      els.forEach(function (e) { e.classList.remove('is-activo'); e.setAttribute('aria-selected', 'false'); });
      indice = (n + els.length) % els.length;
      var el = els[indice];
      el.classList.add('is-activo');
      el.setAttribute('aria-selected', 'true');
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    function pintar(datos, termino) {
      var res = (datos && datos.resources && datos.resources.results) || {};
      var productos = res.products || [];
      var sugeridas = (res.queries || []).filter(function (q) {
        return q.text && q.text.toLowerCase() !== termino.toLowerCase();
      }).slice(0, 3);

      if (!productos.length && !sugeridas.length) {
        caja.innerHTML = '<p class="oc-ac__vacio">No hemos encontrado nada para «' + esc(termino) + '».</p>';
        caja.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }

      var h = '';

      if (sugeridas.length) {
        h += '<p class="oc-ac__titulo">Sugerencias</p>';
        sugeridas.forEach(function (q) {
          h += '<a class="oc-ac__item oc-ac__item--q" role="option" aria-selected="false" href="' + esc(q.url) + '">'
            + '<span class="oc-ac__lupa" aria-hidden="true">⌕</span>'
            + '<span class="oc-ac__qtxt">' + esc(q.text) + '</span></a>';
        });
      }

      if (productos.length) {
        h += '<p class="oc-ac__titulo">Productos</p>';
        productos.forEach(function (p) {
          var precio = p.price != null && p.price !== '' ? fmt.format(parseFloat(p.price)) : '';
          h += '<a class="oc-ac__item" role="option" aria-selected="false" href="' + esc(p.url) + '">'
            + (p.image ? '<img class="oc-ac__img" src="' + esc(miniatura(p.image)) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="oc-ac__img oc-ac__img--vacia" aria-hidden="true"></span>')
            + '<span class="oc-ac__txt"><span class="oc-ac__nombre">' + esc(corto(p.title)) + '</span>'
            + (precio ? '<span class="oc-ac__precio">' + esc(precio) + (p.available ? '' : ' · Agotado') + '</span>' : '')
            + '</span></a>';
        });
      }

      var accion = (form && form.getAttribute('action')) || '/search';
      h += '<a class="oc-ac__item oc-ac__todos" role="option" aria-selected="false" href="'
        + esc(accion) + '?q=' + encodeURIComponent(termino) + '">Ver todos los resultados para «' + esc(termino) + '»</a>';

      caja.innerHTML = h;
      caja.hidden = false;
      indice = -1;
      input.setAttribute('aria-expanded', 'true');
    }

    function buscar(termino) {
      if (controlador) controlador.abort();
      controlador = ('AbortController' in window) ? new AbortController() : null;

      var u = new URL('/search/suggest.json', window.location.origin);
      u.searchParams.set('q', termino);
      u.searchParams.set('resources[type]', 'product,query');
      u.searchParams.set('resources[limit]', String(LIMITE));
      u.searchParams.set('resources[options][unavailable_products]', 'last');

      fetch(u.toString(), {
        headers: { 'Accept': 'application/json' },
        signal: controlador ? controlador.signal : undefined
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (d) { pintar(d, termino); })
        .catch(function (e) { if (e && e.name !== 'AbortError') cerrar(); });
    }

    input.addEventListener('input', function () {
      var t = input.value.trim();
      clearTimeout(temporizador);
      if (t.length < MIN) { cerrar(); return; }
      temporizador = setTimeout(function () { buscar(t); }, RETARDO);
    });

    input.addEventListener('keydown', function (ev) {
      if (caja.hidden) return;
      if (ev.key === 'ArrowDown') { ev.preventDefault(); marcar(indice + 1); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); marcar(indice - 1); }
      else if (ev.key === 'Escape') { cerrar(); }
      else if (ev.key === 'Enter') {
        var els = opciones();
        if (indice >= 0 && els[indice]) { ev.preventDefault(); window.location.assign(els[indice].href); }
      }
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN && caja.innerHTML) {
        caja.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (ev) {
      if (!caja.contains(ev.target) && ev.target !== input) cerrar();
    });
  }

  function init() {
    var inputs = document.querySelectorAll('form[action*="/search"] input[name="q"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].offsetParent !== null || i === 0) new Autocompletar(inputs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
